import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["customerSelect", "contactSelect"]

    connect() {
        this.requestSequence = 0
        this.initSelect2()

        if (this.contactSelectTarget.options.length <= 1) {
            this.update();
        }
    }

    // Clean up Select2 when the element is removed from DOM to prevent 'isConnected' errors
    disconnect() {
        const $element = $(this.customerSelectTarget)
        $element.off('.customerContacts')
        if ($element.data('select2')) $element.select2('destroy');
    }

    initSelect2() {
        const $element = $(this.customerSelectTarget);

        // Find the closest modal parent dynamically
        const $modal = $element.closest('.modal');

        $element.select2({
            dropdownParent: $modal.length ? $modal : $(document.body),
            width: '100%',
            placeholder: 'Select a Customer',
            allowClear: true
        });

        // Listen for Select2 changes to trigger Stimulus update
        $element.on('select2:select.customerContacts select2:clear.customerContacts', () => {
            this.update();
        });
    }

    update() {
        const customerId = this.customerSelectTarget.value;
        if (!customerId) {
            this.contactSelectTarget.innerHTML = '<option value="">Select Contacts</option>';
            return;
        }

        const requestId = ++this.requestSequence
        fetch(`/customers/${customerId}/contacts.json`)
            .then(response => response.json())
            .then(data => {
                if (requestId !== this.requestSequence) return
                const defaultContactIds = new Set(
                    String(this.contactSelectTarget.dataset.defaultContacts || "")
                        .split(",")
                        .map((value) => value.trim())
                        .filter((value) => value.length > 0)
                )
                const optionsHtml = data
                    .map(contact => {
                        const id = String(contact.id)
                        const selected = defaultContactIds.has(id) ? ' selected="selected"' : ""
                        return `<option value="${id}"${selected}>${contact.name}</option>`
                    })
                    .join('');
                this.contactSelectTarget.innerHTML = optionsHtml;

                // Set defaults logic...
                this.contactSelectTarget.dispatchEvent(new Event('change'));
            });
    }
}
